export class CoinFlightEvents {
    public static readonly COIN_FLIGHT_FINISHED: symbol = Symbol('COIN_FLIGHT_FINISHED');
    public static readonly COIN_FLIGHT_STARTED: symbol = Symbol('COIN_FLIGHT_STARTED');
}
